import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../core/authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class MediaPlanService {
    constructor(
        private http: HttpClient,
        private authenticationService: AuthenticationService
    ) {}

    downloadAsExcel(campaignId: string) {
        return this.http.get(
            `${
                environment.apiUrl
            }/media-plan/excel/${campaignId}/${this.authenticationService.getSessionRole()}`,
            { responseType: 'blob' }
        );
    }

    downloadAsPDF(campaignId: string) {
        return this.http.get(
            `${
                environment.apiUrl
            }/media-plan/pdf/${campaignId}/${this.authenticationService.getSessionRole()}`,
            {
                responseType: 'blob'
            }
        );
    }
}
